import { Select, Text } from '@common/ui'
import { com } from '@eidu/web'
import { findFieldById } from '../../util/EntityTypeExtensions'
import Field = com.eidu.entity.field.Field
import fieldIdFromString = com.eidu.entity.field.fieldIdFromString

type FieldSingleSelectProps = {
  label: string
  options: readonly Field[]
  selected: Field | undefined
  setSelected: (field: Field) => void
  entityType: com.eidu.entity.type.EntityType
  errorLabel?: string
  disabled?: boolean
}

const FieldSingleSelect = ({
  label,
  options,
  selected,
  setSelected,
  entityType,
  errorLabel = 'No fields found',
  disabled = false,
}: FieldSingleSelectProps) =>
  options.length > 0 ? (
    <Select
      label={label}
      style={{ minWidth: 160 }}
      value={selected?.id.toString() ?? null}
      disabled={disabled}
      onChange={(value) => {
        if (value === null) return
        const selectedField = findFieldById(entityType, fieldIdFromString(value))
        if (selectedField) {
          setSelected(selectedField)
        }
      }}
      data={options.map((entityField) => ({ value: entityField.id.toString(), label: entityField.name }))}
    />
  ) : (
    <Text size="sm" c="negative">
      {errorLabel}
    </Text>
  )

export default FieldSingleSelect
